import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControlName } from '@angular/forms';
import { EaDocumentFormComponent } from '@app/forms/documents/ea-document-form/ea-document-form.component';
import { GedPickerComponent } from '../pr-ged-picker/ged-picker.component';
import { PrFormService } from '../pr-form/pr-form.service';
import { PrTable, PrTableColumn } from '../pr-table/pr-table.component';

@Component({
  selector: 'pr-file',
  templateUrl: './pr-file.component.html',
  styleUrls: ['./pr-file.component.scss'],
  standalone: false,
})
export class PrFileComponent implements OnInit, OnChanges {
  @ContentChild(FormControlName) control: FormControlName;

  //@ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef;

  @Output() fileChange = new EventEmitter<any>();

  @Input() gedAccountId: any;

  @Input() gedDocuments: string[];

  @Input() gedOwnerId: number;

  @Output() gedDocumentSelected = new EventEmitter<any>();

  @ViewChild('gedPickerRef') gedPickerRef: GedPickerComponent;

  files: any[] = [];

  @Input() form: boolean;

  @Input() user: any;

  @Input() fileForm: any;

  @Input() resetFiles: boolean = false;

  error: string;

  table: PrTable;
  data: any;

  columnsDefinition = [
    new PrTableColumn('Nom du document', 'name'),
    new PrTableColumn('', '', 'action'),
  ];

  constructor(private prFormService: PrFormService) {}

  openGedPicker() {
    this.gedPickerRef?.open();
  }

  ngOnInit() {
    this.error = null;
    if (this.fileForm != null) {
      this.prepareFilesList(this.fileForm);
    }
  }

  initTable() {
    this.table = new PrTable(this.files, this.columnsDefinition);
  }

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    if (this.form === true) {
      this.prepareFilesList($event);
    } else {
      this.prFormService.trigger(EaDocumentFormComponent, {
        accountId: this.user.accountId,
        file: $event,
      });
    }
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    if (this.form === true) {
      this.prepareFilesList(files);
    } else {
      this.prFormService.trigger(EaDocumentFormComponent, {
        accountId: this.user.accountId,
        file: files,
      });
    }
  }

  deleteDocument(document) {
    const fileIndex = [...this.files].findIndex(file => file == document);
    this.files.splice(fileIndex, 1);

    this.initTable();

    this.fileChange.emit(this.files);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      if (item.size < 20971520) {
        if (
          item.type === 'application/pdf' ||
          item.type === 'image/jpeg' ||
          item.type === 'image/png'
        ) {
          this.files.push(item);
          this.fileChange.emit(this.files);
          this.error = null;
        } else {
          this.error =
            'Désolé, ce type de fichier n’est pas autorisé pour des raisons de sécurité (format accepté : JPEG, PNG, PDF)';
        }
      } else {
        this.error =
          'Fichier trop volumineux, la limite de volume est fixée à 20MB';
      }
    }
    this.initTable();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.resetFiles && changes.resetFiles.currentValue === true) {
      this.files = [];
      this.initTable();
      this.resetFiles = false;
    }
  }
}
